module.exports = __webpack_public_path__ + "b8bb6136e8bbbcec48554ff72034bf6b.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/docs/downloadfiles.png
// module id = 1480
// module chunks = 1